import { useEffect, useState } from 'react';
import { Modal } from '../../../../components/Modal';
import { PAYMENT_METHOD_LABELS, readLastPaymentMethod, saveLastPaymentMethod } from '../../../vendas/helpers';
import { useDefaultPaymentMethod } from '../../../financeiro/useDefaultPaymentMethod';

interface PaymentMethodModalProps {
    title: string;
    confirmLabel: string;
    /** Forma ja registrada, quando a equipe esta corrigindo o pagamento. */
    currentMethod?: string;
    onClose: () => void;
    onConfirm: (paymentMethod: string) => Promise<void>;
}

export default function PaymentMethodModal({ title, confirmLabel, currentMethod, onClose, onConfirm }: PaymentMethodModalProps) {
    const defaultMethod = useDefaultPaymentMethod();
    const [method, setMethod] = useState(currentMethod ?? readLastPaymentMethod());
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (defaultMethod && !currentMethod) setMethod(defaultMethod);
    }, [defaultMethod, currentMethod]);

    const confirm = async () => {
        setSaving(true);
        try {
            saveLastPaymentMethod(method);
            await onConfirm(method);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal title={title} subTitle="Como o cliente pagou?" onClose={onClose} desktopClassName="sm:!max-w-md">
            <div className="flex flex-col gap-4">
                <div className="grid grid-cols-2 gap-2" role="radiogroup" aria-label="Forma de pagamento">
                    {Object.entries(PAYMENT_METHOD_LABELS).map(([value, label]) => (
                        <button
                            key={value}
                            type="button"
                            role="radio"
                            aria-checked={method === value}
                            className={`btn ${method === value ? 'btn-primary' : 'btn-ghost border border-base-300'}`}
                            onClick={() => setMethod(value)}
                        >
                            {label}
                        </button>
                    ))}
                </div>
                <button type="button" className="btn btn-primary" onClick={confirm} disabled={saving}>
                    {saving && <span className="loading loading-spinner loading-sm"></span>}
                    {confirmLabel}
                </button>
            </div>
        </Modal>
    );
}
